import { render, staticRenderFns } from "./form-prev.vue?vue&type=template&id=60c4e2cf"
import script from "./form-prev.vue?vue&type=script&lang=js"
export * from "./form-prev.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports